import { alpha, styled } from '@mui/material';
import { Colors } from '@/constants/colorTypes';
import { useState } from 'react';

const imageFiles = import.meta.glob<string>('../../assets/images/*', {
  eager: true,
  import: 'default',
});

interface ImageProps {
  id: string;
  alt: string | null;
  width: string | null;
  margin?: string | null;
  backgroundColor: Colors | null;
}

export const Image: React.FC<ImageProps> = ({ id, alt, width, margin, backgroundColor }) => {
  const [isLoaded, setIsLoaded] = useState<boolean>(false);
  const src = imageFiles[`../../assets/images/${id}.png`] || null;
  const srcAvif = imageFiles[`../../assets/images/${id}.avif`] || null;

  if (!src) {
    return null;
  }

  return (
    <picture>
      {srcAvif && (
        <source
          srcSet={srcAvif}
          type='image/avif'
        />
      )}
      <Img
        src={src}
        alt={alt ?? undefined}
        onLoad={() => setIsLoaded(true)}
        imgWidth={width ? `${width}px` : '100%'}
        imgMargin={margin ?? '0'}
        isLoaded={isLoaded}
        backgroundColor={backgroundColor}
      />
    </picture>
  );
};

interface ImgProps {
  imgWidth: string;
  imgMargin: string;
  isLoaded: boolean;
  backgroundColor: Colors | null;
}

const Img = styled('img')<ImgProps>`
  display: block;
  width: ${(props) => props.imgWidth};
  margin: ${(props) => props.imgMargin};
  height: auto;
  transition: opacity 0.5s ease-out;
  opacity: ${(props) => (props.isLoaded ? 1 : 0)};
  ${({ theme, backgroundColor }) =>
    backgroundColor && `background-color: ${alpha(theme.palette[backgroundColor]?.main, 0.15)};`}
`;
